(function(){
  'use strict';

  angular.module('eclipseApp.core').factory('notifierService', ['$rootScope', '$state', 'uteModal', function($rootScope, $state, uteModal){
    var notifications = {
      error: function(code){
        console.log('@notifierService:error(@code) ', code);
        switch (code) {
          default:
            uteModal.open({
              templateUrl: 'modules/core/views/technical-modal.html',
              controller: 'ErrorTechnicalModalCtrl',
              data: {
                errorMsg: code
              }
            });
        }
      },


      loading: function(visibility, code){

        console.log('@notifierService:loading ', visibility);

        if (visibility === 'show' || visibility === 'start') {
          uteModal.open({
            templateUrl: 'modules/core/views/loading-modal.html',
            controller: 'NotifierLoadingModalCtrl',
            backdrop: 'static',
            data: {
              errorMsg: code
            }
          });
        } else if (visibility === 'close') {
          console.log('@notifierService:loading:close', visibility);

          $rootScope.$broadcast('NotifierLoading:Done');

        } else if (visibility === 'stop') {

          $rootScope.$broadcast('NotifierLoading:Stop');
        }

      },

      // tbd
      technical: function(code){
        console.log('@notifierService:technical:code ', code);
        switch (code) {
          default:
            uteModal.open({
              templateUrl: 'modules/core/views/technical-modal.html',
              controller: 'ErrorTechnicalModalCtrl',
              data: {
                errorMsg: code
              }
            });
        }
      },

      general: function(code){
      },
    };



    return {
      notify: function(notificationType, code){
        notifications[notificationType](code);
      },
      error: function(errorCode){
        notifications.error(errorCode);
      },
      loading: function(visibility){
        notifications.loading(visibility);
      }
    };
  }])
})();
